export default __webpack_public_path__ + "static/FritzphoneC4_04-a6106a453c3be0cc53fa1e6a15e2acea.webp";